module.exports = __webpack_public_path__ + "media/assets/images/quotation_detail2-10e4df8af7609bc1e56dab290f40ce2d.png";